import { Alert, Button, Form, Input } from "antd";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/auth/AuthContext";

interface LoginFormValues {
  readonly token: string;
}

export function LoginPage() {
  const { login, lastAuthError } = useAuth();
  const [form] = Form.useForm<LoginFormValues>();

  const handleFinish = (values: LoginFormValues) => {
    login(values.token);
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-6 overflow-hidden">
      <div className="crow-blob crow-blob-a w-[420px] h-[420px] -top-32 -left-24" />

      <div className="relative z-10 w-full max-w-md crow-fade-up">
        <div className="bg-surface-elevated rounded-arc-xl border border-arc-border shadow-arc-xl overflow-hidden">
          <div className="p-10">
            <div className="flex justify-center mb-8">
              <Logo size="lg" />
            </div>

            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-content-primary mb-2">
                Sign in
              </h1>
              <p className="text-content-secondary text-sm">
                Paste your Crowlingo API token to view your usage.
              </p>
            </div>

            {lastAuthError && (
              <Alert
                type="error"
                message={lastAuthError}
                showIcon
                className="!mb-5 !rounded-arc-md"
              />
            )}

            <Form
              form={form}
              layout="vertical"
              onFinish={handleFinish}
              requiredMark={false}
            >
              <Form.Item<LoginFormValues>
                name="token"
                label={
                  <span className="text-content-primary font-medium">
                    API token
                  </span>
                }
                rules={[
                  { required: true, message: "Token is required" },
                  {
                    validator: (_, value: string) =>
                      value && value.trim().length > 0
                        ? Promise.resolve()
                        : Promise.reject(new Error("Token cannot be empty")),
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="myorga_user-xxxxxxxxxxxxxxxxxxxx"
                  autoComplete="off"
                  autoFocus
                />
              </Form.Item>

              <Form.Item className="!mb-0">
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  style={{
                    background: "#6366F1",
                    border: "none",
                    height: 46,
                    fontWeight: 600,
                  }}
                >
                  Continue
                </Button>
              </Form.Item>
            </Form>

            <p className="text-center text-xs text-content-tertiary mt-8">
              Your token is kept in this browser tab only.
            </p>
          </div>
        </div>

        <p className="text-center text-xs text-content-tertiary mt-6">
          Powered by Crowlingo
        </p>
      </div>
    </div>
  );
}
